import DesignTeamShifter from "../components/DesignTeamShifter"
import DesignTeamUsersUpdate from '../components/DesignTeamUsersUpdate'
import DesignUserUpdate from '../components/DesignUserUpdate'

export default class DesignTeamsDesignTeamUsers {
  index() {
    new DesignTeamShifter()
    N2.bindGlobalHandler('pm:design-user-update', () => {
      new DesignUserUpdate(event.detail)
    })

    N2.bindGlobalHandler('pm:design-user-destroy', () => {
      $(event.detail.target).slideUp();
    })
  }
}
